import styled from "styled-components";

const SearchBox = styled.div`
    input {
        width: 100%;
        border: none;
        border-radius: 0;
        height: 35px;
        padding: 3px 10px;
    }
    button {
        border-radius: 0px;
        background-color: #aaa;
        color: #fff !important;
        border: none;
        line-height: 35px;
        padding: 0 15px;
        &:hover {
            background-color: #474747;
        }
    }

    .mailchimp-form {
        > div:not(.error-messages) {
            display: flex;
            flex-wrap: wrap;
            > div {
                width: 100%;
            }
        }
        input {
            width: calc(100% - 100px);
        }
        button {
            width: 100px;
        }
    }
`;
export default SearchBox;
